import type { JSX } from "react";
import { AppProviders } from "./providers";
import { RouterProvider } from "./providers/RouterProvider";
import { Toaster } from "@/components/ui/sonner";

export function App(): JSX.Element {
  return (
    <AppProviders>
      <RouterProvider />
      <Toaster />
    </AppProviders>
  );
}
